exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search[data-v-02e88a40]{float:right;width:400px;margin-bottom:20px}.sprite-container[data-v-02e88a40]{display:grid;grid-template-columns:repeat(3,1fr);grid-gap:10px;grid-auto-rows:minmax(100px,auto)}.sprite[data-v-02e88a40]{position:relative;height:96px}.sprite-preview[data-v-02e88a40]{position:absolute;top:0;left:0;width:64px;height:96px;background-size:auto 96px;-ms-interpolation-mode:nearest-neighbor;image-rendering:pixelated;image-rendering:crisp-edges}.sprite-name[data-v-02e88a40]{position:absolute;top:20px;left:95px;font-weight:700}.sprite-author[data-v-02e88a40]{position:absolute;top:50px;left:95px}", ""]);

// exports
